/**
 * Orderable hardware and services, for the order / quote form.
 *
 * No prices: hardware and software licences are quoted (partner discounts and
 * volume change the number), so the form collects intent and quantities and a
 * person replies. Cloud plans, which are self-serve, live in ./plans.
 */

export interface CatalogItem {
  sku: string;
  name: string;
  description: string;
  group: 'appliance' | 'expansion' | 'accessory' | 'service';
  /** Pre-filled quantity on the order form. */
  defaultQuantity: number;
}

export const ORDER_CATALOG: CatalogItem[] = [
  {
    sku: 'SI-APP-CM4',
    name: 'Scada.Ink Appliance',
    description: 'Preconfigured edge appliance with analog inputs, digital I/O and RS-232/RS-485.',
    group: 'appliance',
    defaultQuantity: 1,
  },
  {
    sku: 'SI-EXP-DIO',
    name: 'Digital I/O Expansion Card',
    description: 'Additional digital inputs and outputs over the quick-connect cable.',
    group: 'expansion',
    defaultQuantity: 0,
  },
  {
    sku: 'SI-EXP-AIO',
    name: 'Analog I/O Expansion Card',
    description: 'Additional 4–20 mA / 0–10 V channels.',
    group: 'expansion',
    defaultQuantity: 0,
  },
  {
    sku: 'SI-ACC-DIN',
    name: 'DIN-Rail / Panel Mount Kit',
    description: 'Mounting hardware for control-panel installation.',
    group: 'accessory',
    defaultQuantity: 0,
  },
  {
    sku: 'SI-ACC-QCC',
    name: 'Quick-Connect Cable Set',
    description: 'Spare expansion cables.',
    group: 'accessory',
    defaultQuantity: 0,
  },
  {
    sku: 'SI-SVC-COMM',
    name: 'Remote Commissioning',
    description: 'A Scada.Ink engineer connects devices and builds your first dashboards with you.',
    group: 'service',
    defaultQuantity: 0,
  },
  {
    sku: 'SI-SVC-CERT',
    name: 'Certification Exam Voucher',
    description: 'Proctored exam voucher for an Ink U certification.',
    group: 'service',
    defaultQuantity: 0,
  },
];

export const SOFTWARE_TIERS: Array<{ id: 'community' | 'professional' | 'enterprise'; name: string; summary: string }> = [
  {
    id: 'community',
    name: 'Community',
    summary: 'Every PLC, CNC and robot driver, unlimited tags, dashboards, historian, scripts, workflows, custom pages and paired appliances.',
  },
  {
    id: 'professional',
    name: 'Professional',
    summary: 'Adds OEE, downtime, quality, andon, alarm pipelines, reporting, ladder logic and store-and-forward.',
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    summary: 'Adds work orders, recipes, work instructions, labor efficiency, symbols, SFC and Sparkplug B.',
  },
];

/** Choices on the order form: the Scada.Ink tiers and the HMI.ink package. */
export const ORDER_SOFTWARE_OPTIONS: Array<{ id: 'community' | 'professional' | 'enterprise' | 'hmi'; name: string; summary: string }> = [
  ...SOFTWARE_TIERS,
  {
    id: 'hmi',
    name: 'HMI.ink',
    summary: 'A focused HMI: network scanner, tag browser, dashboards with buttons and custom HTML screens. $999 per appliance.',
  },
];
